import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../style/personalize_colors.css';
import { useDispatch, useSelector } from 'react-redux';
import { contains } from 'jquery';

const EditarLiquidaciones = () => {
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Estados principales
  const { user } = useSelector(state => state.auth);
  const [respuestaApi, setRespuestaApi] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);
  const [fechaConsulta, setFechaConsulta] = useState(getCurrentDate());
  const [fechaConsulta1, setFechaConsulta1] = useState(getCurrentDate());
  const [fechaConsulta2, setFechaConsulta2] = useState(getCurrentDate());
  
  // Estados para el seguimiento
  const [opcionesSeguimiento, setOpcionesSeguimiento] = useState([]);
  const [opcionesEstado, setOpcionesEstado] = useState([]);
  const [cargandoSeguimiento, setCargandoSeguimiento] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [liquidacionSeleccionada, setLiquidacionSeleccionada] = useState(null);
  const [estadoSeleccionado, setEstadoSeleccionado] = useState('');
  const [seguimientoSeleccionado, setSeguimientoSeleccionado] = useState('');
  const [responsableSeleccionado, setResponsableSeleccionado] = useState('');
  const [comentario, setComentario] = useState('');
  const [accionActual, setAccionActual] = useState('');
  const [arearesponsableSeleccionado, setareaResponsableSeleccionado] = useState('');
  const [opcionesArea, setOpcionesArea] = useState([]);

  const [showBitacoraModal, setShowBitacoraModal] = useState(false);
  const [bitacoraData, setBitacoraData] = useState(null);

  const [filtrosActivos, setFiltrosActivos] = useState([]);
  const [gruposEstado, setGruposEstado] = useState([]);
  const [liquidacionesOrdenadas, setLiquidacionesOrdenadas] = useState([]);

  const [usarFecha, setUsarFecha] = useState(true);
  const [usarFecha2, setUsarFecha2] = useState(false);
  const [bitacoraItem, setBitacoraItem] = useState(null);
  
  // Estados para el sidebar
  const [showSidebar, setShowSidebar] = useState(false);
  const [sidebarData, setSidebarData] = useState([]);

  const ahora = new Date();
  const opciones = {
    timeZone: 'America/Guatemala',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  };

  const fechaHora = ahora.toLocaleString('es-GT', opciones);

  // Estados para los filtros
  const [filters, setFilters] = useState({
    numRef: '',
    cliente: '',
    documento: '',
    estado: '',
    fechaDesde: '',
    fechaHasta: '',
    montoDesde: '',
    montoHasta: '',
    fechaSeguimientoDesde: '',
    fechaSeguimientoHasta: '',
    condicionPago: '',
    factura: ''
  });

  // Datos de ejemplo para responsables
  const responsables = [
    { id: 12, nombre: 'Juan Pérez' },
    { id: 15, nombre: 'María García' },
    { id: 18, nombre: 'Carlos López' },
    { id: 45, nombre: 'Ana Martínez' }
  ];

  const datosParaEnviar = {
    Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
    Ambiente: 'DESA',
    Dispositivo: {
      Marca: 'SAMSUNG',
      Modelo: 'S22002B',
      Version: 'Android 18.125',
      McAdress: null,
      PowerStatus: '84%',
      WifiStatus: 'Conected to iphone de Mauricio',
      GPSStatus: 'ON',
      GPS: '321|-485|321'
    },
    Usr: {
      Codigo: '',
      UserNickName: 'pierril'
    },
    DatosMetodo: {
      NombreMetodo: 'ObtenerListaLiquidacionesWeb',
      Datos_Recibidos: '',
      datos_Generados: ''
    }
  };

  // Función para mostrar el sidebar
  const handleShowSidebar = () => {
    if (cargando || filteredData.length === 0) {
      return;
    }
    
    const datosSidebar = filteredData.map(item => ({
      factura: item.Num_Ref || '-',
      documento: item.Num_Documento || '-',
      cliente: item.Nombre_CLiente || '-',
      fecha: formatearFecha(item.Fecha_Doc) || '-',
      total: `Q ${item.Total_Documento?.toFixed(2) || '0.00'}`,
      condicion: item.Condicion_Pago || '-',
      estado: item.est_nombre || '-',
      responsable: item.nombre_departamento || '-',
      fechaSeguimiento: formatearFecha(item.sp_fecha) || '-'
    }));
    
    setSidebarData(datosSidebar);
    setShowSidebar(true);
  };

  const handleShowBitacora = (item) => {
    console.log('entro1')
    console.log(item)
    console.log(item.Bitacora)
    if (item.Bitacora !== "") {
      console.log('entro2')
      setBitacoraItem(item);
      setShowBitacoraModal(true);
    } else {
      console.log('entro3')
      alert("Bitacora sin registros");
    }
  };

  // Función para filtrar los datos
  const filteredData = respuestaApi.filter(item => {
    if (filters.numRef && !item.Num_Ref?.toLowerCase().includes(filters.numRef.toLowerCase())) {
      return false;
    }
    if (filters.cliente &&
      !item.Codigo_Cliente?.toLowerCase().includes(filters.cliente.toLowerCase()) &&
      !item.Nombre_CLiente?.toLowerCase().includes(filters.cliente.toLowerCase())) {
      return false;
    }

    if (filters.documento && !item.Num_Documento?.toString().toLowerCase().includes(filters.documento.toLowerCase())) {
      return false;
    }
    if (filters.factura && !item.Distribuidora?.toString().toLowerCase().includes(filters.factura.toLowerCase())) {
      return false;
    }

    if (filters.estado) {
      const estadoItem = item.est_nombre || item.Pagado || item.sp_estado;
      if (!estadoItem || !estadoItem.toLowerCase().includes(filters.estado.toLowerCase())) {
        return false;
      }
    }

    if (filters.fechaDesde || filters.fechaHasta) {
      const fechaDoc = new Date(item.Fecha_Doc);
      const desde = filters.fechaDesde ? new Date(filters.fechaDesde) : null;
      const hasta = filters.fechaHasta ? new Date(filters.fechaHasta) : null;
      if (desde && fechaDoc < desde) return false;
      if (hasta && fechaDoc > hasta) return false;
    }

    if (filters.fechaSeguimientoDesde || filters.fechaSeguimientoHasta) {
      const fechaSeg = item.sp_fecha ? new Date(item.sp_fecha) : null;
      if (!fechaSeg) return false;

      const desde = filters.fechaSeguimientoDesde ? new Date(filters.fechaSeguimientoDesde) : null;
      const hasta = filters.fechaSeguimientoHasta ? new Date(filters.fechaSeguimientoHasta) : null;

      if (desde && fechaSeg < desde) return false;
      if (hasta && fechaSeg > hasta) return false;
    }

    if (filters.condicionPago && !item.Condicion_Pago?.toLowerCase().includes(filters.condicionPago.toLowerCase())) {
      return false;
    }

    if (filters.montoDesde || filters.montoHasta) {
      const monto = item.Total_Documento || 0;
      const desde = parseFloat(filters.montoDesde) || 0;
      const hasta = parseFloat(filters.montoHasta) || Infinity;
      if (monto < desde || monto > hasta) return false;
    }

    if (filtrosActivos.length > 0 && !filtrosActivos.includes(item.est_codigo)) {
      return false;
    }

    return true;
  });

  const agruparPorEstado = (data) => {
    if (!data || !Array.isArray(data)) return [];

    const agrupado = data.reduce((acc, item) => {
      const key = `${item.est_codigo}-${item.est_nombre}`;
      if (!acc[key]) {
        acc[key] = {
          est_codigo: item.est_codigo,
          est_nombre: item.est_nombre,
          count: 0
        };
      }
      acc[key].count++;
      return acc;
    }, {});

    return Object.values(agrupado);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const fetchOpcionesSeguimiento = async () => {
    try {
      setCargandoSeguimiento(true);

      const requestData = {
        Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
        Ambiente: 'DESA',
        Dispositivo: {
          Marca: 'SAMSUNG',
          Modelo: 'S22002B',
          Version: 'Android 18.125',
          McAdress: null,
          PowerStatus: '84%',
          WifiStatus: 'Conected to iphone de Mauricio',
          GPSStatus: 'ON',
          GPS: '321|-485|321'
        },
        Usr: {
          Codigo: '',
          UserNickName: 'pierril'
        },
        DatosMetodo: {
          NombreMetodo: 'ObtenerListaCatalogosSeguimientoLiqui',
          Datos_Recibidos: ''
        }
      };

      const url = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(requestData))}`;
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }

      const data = await response.json();

      if (!data.datos_Generados) {
        throw new Error('No se encontraron datos generados');
      }

      const datosGenerados = JSON.parse(data.datos_Generados);
      const opcionesSeguimientoFiltradas = (datosGenerados.CATALOGOS || []).filter(
        opcion => opcion.TipoLista === 'SEGUIMIENTO' && opcion.est_codigo !== 15 && opcion.est_codigo !== 6
      );
      const opcionesEstadoFiltradas = (datosGenerados.CATALOGOS || []).filter(
        opcion => opcion.TipoLista === 'ESTADO' && opcion.est_codigo !== 15 && opcion.est_codigo !== 6
      );

      setOpcionesSeguimiento(opcionesSeguimientoFiltradas);
      setOpcionesEstado(opcionesEstadoFiltradas);
      const opcionesFiltradas2 = (datosGenerados.CATALOGOS || []).filter(
        opcion => opcion.TipoLista === 'DEPARTAMENTOS'
      );
      setOpcionesArea(opcionesFiltradas2)

    } catch (err) {
    } finally {
      setCargandoSeguimiento(false);
    }
  }; 

  const quitarDuplicados = (data) => {
  const vistos = new Set();

  return data.filter((item) => {
    // Si el registro es idéntico, esta llave será igual
    const key = JSON.stringify(item);

    if (vistos.has(key)) {
      return false;
    }

    vistos.add(key);
    return true;
  });
};

  const consultarApi = async () => {
    setCargando(true);
    setError(null);

    console.log(usarFecha);

    try {
      let datosRecibidos = {};

      if (usarFecha) {
        if (!fechaConsulta) {
          throw new Error("Debe seleccionar una fecha cuando la opción 'Usar fecha' está activada");
        }
        datosRecibidos = { Fecha: fechaConsulta, IdUsuario: user.id_usuario };
      } else if (usarFecha2) {
        if (!fechaConsulta) {
          throw new Error("Debe seleccionar una fecha cuando la opción 'Usar fecha 2' está activada");
        }
        console.log('------')
        console.log(user);
        console.log(user.rol.some(rol => rol.Id_Perfil === 140002));
        if (user.rol.some(rol => rol.Id_Perfil === 140002)) {
          console.log('entro -----')
          datosRecibidos = {
            FechaIni: fechaConsulta1,
            FechaFin: fechaConsulta2,
            Rol: '140002'
          };
        } else {
          datosRecibidos = {
            FechaIni: fechaConsulta1,
            FechaFin: fechaConsulta2,
            IdUsuario: user.id_usuario
          };
        }
      } else {
        datosRecibidos = { Tipo: 'Solo Pendiente' };
      }

      const requestData = {
        ...datosParaEnviar,
        DatosMetodo: {
          ...datosParaEnviar.DatosMetodo,
          Datos_Recibidos: JSON.stringify(datosRecibidos)
        }
      };

      const url = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(requestData))}`;
      const respuesta = await fetch(url);

      if (!respuesta.ok) {
        throw new Error(`Error HTTP: ${respuesta.status}`);
      }

      const datos = await respuesta.json(); 
      console.log(datos);

      if (!datos.datos_Generados) {
        throw new Error('No se encontraron datos generados en la respuesta');
      }
      const datosGenerados = JSON.parse(datos.datos_Generados);
      let liquidaciones = datosGenerados.LIQUIDACION || [];
      if (user.rol.some(rol => rol.Id_Perfil === 140001)) {
        liquidaciones = liquidaciones.filter(i => i.Condicion_Pago.toUpperCase().includes('CONT'));
        console.log(liquidaciones)
      }
      if (user.rol.some(rol => rol.Id_Perfil === 140002)) {
        liquidaciones = liquidaciones.filter(i => i.Condicion_Pago.includes('CRED'));
      }

      const liquidacionesConSeguimiento = Array.isArray(liquidaciones)
        ? liquidaciones.filter(item => item.sp_codigo !== undefined && item.sp_codigo !== null)
        : (liquidaciones.sp_codigo ? [liquidaciones] : []);

      console.log(liquidacionesConSeguimiento)
     const liquidacionesSinDuplicados = quitarDuplicados(liquidacionesConSeguimiento);

      const liquidacionesOrdenadas = liquidacionesSinDuplicados.sort((a, b) => {
        if (a.est_codigo === 15) return -1;
        if (b.est_codigo === 15) return 1;
        if (a.est_codigo === 6) return 1;
        if (b.est_codigo === 6) return -1;
        return 0;
      });
      console.log(liquidacionesOrdenadas)
      setRespuestaApi(liquidacionesOrdenadas);
      setLiquidacionesOrdenadas(liquidacionesOrdenadas);
setGruposEstado(agruparPorEstado(liquidacionesOrdenadas));
    } catch (err) {
      setError(err.message);
    } finally {
      setCargando(false);
    }
  };

  const handleEditarSeguimientoClick = (liquidacion) => {
    setAccionActual('editar');
    setLiquidacionSeleccionada(liquidacion);
    if (liquidacion.CodSeg) {
      setEstadoSeleccionado(liquidacion.Estado?.toString() || '');
      setSeguimientoSeleccionado(liquidacion.Seguimiento?.toString() || '');
      setResponsableSeleccionado(liquidacion.Responsable?.toString() || '');
      setComentario(liquidacion.Comentario || '');
    } else {
      setEstadoSeleccionado('');
      setSeguimientoSeleccionado('');
      setResponsableSeleccionado('');
      setComentario('');
    }
    setShowModal(true);
  };

  const handleCerrarSeguimientoClick = (liquidacion) => {
    if (window.confirm('¿Está seguro de cerrar esta liquidación?')) {
      const seguimientoData = {
        CodSeg: liquidacion.sp_codigo,
        CodCliente: liquidacion.Codigo_Cliente,
        DocNumOINV: liquidacion.Num_Documento,
        NumAtCard: liquidacion.Num_Ref,
        Estado: 6,
        Responsable: 0,
        Comentario: ''
      };
      cerrarSeguimiento(seguimientoData);
    }
  };

  const confirmarAccion = () => {
    if (!estadoSeleccionado || !arearesponsableSeleccionado) {
      alert('Por favor complete todos los campos obligatorios');
      return;
    }

    const seguimientoData = {
      CodSeg: liquidacionSeleccionada.sp_codigo,
      CodCliente: liquidacionSeleccionada.Codigo_Cliente,
      DocNumOINV: liquidacionSeleccionada.Num_Documento,
      NumAtCard: liquidacionSeleccionada.Num_Ref,
      Estado: parseInt(estadoSeleccionado),
      Responsable: parseInt(responsableSeleccionado),
      AreaResponsable: parseInt(arearesponsableSeleccionado),
      Comentario: comentario,
      Id_Usuario: user.id_usuario
    };

    setRespuestaApi(liquidacionesOrdenadas);
    setLiquidacionesOrdenadas(liquidacionesOrdenadas);
    setGruposEstado(agruparPorEstado(liquidacionesOrdenadas));

    const seguimientoData2 = {
      CodSeg: liquidacionSeleccionada.sp_codigo,
      CodCliente: liquidacionSeleccionada.Codigo_Cliente,
      DocNumOINV: liquidacionSeleccionada.Num_Documento,
      NumAtCard: liquidacionSeleccionada.Num_Ref,
      Estado: 6,
      Responsable: 0,
      Comentario: '',
      Id_Usuario: user.id_usuario
    };

    if (accionActual === 'editar') {
      actualizarSeguimiento(seguimientoData);
    } else {
      cerrarSeguimiento(seguimientoData);
    }

    setShowModal(false);
  };

  const actualizarSeguimiento = async (seguimientoData) => {
    try {
      setCargando(true);

      const requestData = {
        Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
        Ambiente: 'DESA',
        Dispositivo: {
          Marca: 'SAMSUNG',
          Modelo: 'S22002B',
          Version: 'Android 18.125',
          McAdress: null,
          PowerStatus: '84%',
          WifiStatus: 'Conected to iphone de Mauricio',
          GPSStatus: 'ON',
          GPS: '321|-485|321'
        },
        User: {
          Codigo: '',
          UserNickName: 'pierril'
        },
        Metodo: {
          NombreMetodo: 'ActualizarSeguimiento',
          Datos_Recibidos: JSON.stringify(seguimientoData),
          datos_Generados: ''
        }
      };
      console.log(requestData);
      const url = 'https://appcorp.parma.com.gt/API/ReceptorDatos';
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData)
      });

      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }

      const data = await response.json();
      console.log(data)
      if (!data.datos_Recibidos) {
        throw new Error('La API no devolvió datos generados');
      }

      alert('Seguimiento actualizado exitosamente');
      consultarApi();

    } catch (err) {
      alert(`Error al actualizar seguimiento: ${err.message}`);
    } finally {
      setCargando(false);
    }
  };

  const cerrarSeguimiento = async (seguimientoData) => {
    try {
      setCargando(true);

      const requestData = {
        Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
        Ambiente: 'DESA',
        Dispositivo: {
          Marca: 'SAMSUNG',
          Modelo: 'S22002B',
          Version: 'Android 18.125',
          McAdress: null,
          PowerStatus: '84%',
          WifiStatus: 'Conected to iphone de Mauricio',
          GPSStatus: 'ON',
          GPS: '321|-485|321'
        },
        User: {
          Codigo: '',
          UserNickName: 'pierril'
        },
        Metodo: {
          NombreMetodo: 'CerrarSeguimiento',
          Datos_Recibidos: JSON.stringify(seguimientoData),
          datos_Generados: ''
        }
      };

      const url = 'https://appcorp.parma.com.gt/API/ReceptorDatos';
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData)
      });

      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }

      const data = await response.json();

      if (!data.datos_Recibidos) {
        throw new Error('La API no devolvió datos generados');
      }

      alert('Seguimiento cerrado exitosamente');
      consultarApi();

    } catch (err) {
      alert(`Error al cerrar seguimiento: ${err.message}`);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    console.log(user.rol);
    consultarApi();
    fetchOpcionesSeguimiento();
  }, []);

  const formatearFecha = (fechaISO) => {
    if (!fechaISO) return '';
    const fecha = new Date(fechaISO);
    return fecha.toLocaleDateString('es-GT');
  };

  const handleFechaChange = (e) => {
    setFechaConsulta(e.target.value);
  };
  const handleFechaChange1 = (e) => {
    setFechaConsulta1(e.target.value);
  };

  const handleFechaChange2 = (e) => {
    setFechaConsulta2(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    consultarApi();
  };

  const handleLimpiarFiltros = () => {
    setFilters({
      numRef: '',
      documento: '',
      cliente: '',
      condicionPago: '',
      estado: '',
      fechaSeguimientoDesde: '',
      fechaSeguimientoHasta: '',
      factura: ''
    });
  };

  const validateStyleCard = (EST) => {
    const headerClass = EST === 'Revisado' ? ' bg-warning' :
      EST === 'Liquidado' ? ' bg-success text-white' : ' bg-light';
    const hcl = "card-header " + headerClass + " d-flex justify-content-between align-items-center";
    return hcl;
  }

  const enviarnotificaciones = async () => {
    try {
      setCargando(true);

      const requestData = {
        Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
        Ambiente: 'DESA',
        Dispositivo: {
          Marca: 'SAMSUNG',
          Modelo: 'S22002B',
          Version: 'Android 18.125',
          McAdress: null,
          PowerStatus: '84%',
          WifiStatus: 'Conected to iphone de Mauricio',
          GPSStatus: 'ON',
          GPS: '321|-485|321'
        },
        User: {
          Codigo: '',
          UserNickName: 'pierril'
        },
        Metodo: {
          NombreMetodo: 'CorreoVendedores',
          Datos_Recibidos: '',
          datos_Generados: ''
        }
      };
      console.log(requestData)
      const url = 'https://appcorp.parma.com.gt/API/ReceptorDatos';
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData)
      });

      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }

      const data = await response.json();

    } catch (err) {

    } finally {
      setCargando(false);
    }
  }

  const imprimirRegistrosEstado6 = () => {
   const liquidacionesOrdenadas = quitarDuplicados([...filteredData]).sort((a, b) => {
    if (a.est_codigo === 15) return -1;
    if (b.est_codigo === 15) return 1;
    if (a.est_codigo === 6) return 1;
    if (b.est_codigo === 6) return -1;
    return 0;
  });

  const registrosParaImprimir = liquidacionesOrdenadas;

  if (registrosParaImprimir.length === 0) {
    alert('No hay registros para imprimir');
    return;
  }

    const ventanaImpresion = window.open('', '_blank');

    let contenidoHTML = `
      <html>
        <head>
          <title>Reporte de Liquidaciones </title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            h1 { color: #333; text-align: center; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 5px; text-align: left; }
            th { background-color: #f2f2f2; }
            .no-data { text-align: center; padding: 20px; }
            @media print {
              body { margin: 0; padding: 0; }
              .no-print { display: none; }
            }
          </style>
        </head>
        <body>
          <h1>Reporte de Liquidaciones </h1>
          <p>Total de registros: ${registrosParaImprimir.length}</p> 
          <p>Dia de Recepcion: ${fechaHora}</p> 
          <table>
            <thead>
              <tr>
                <th>No. Linea</th>
                <th>No.Factura.</th>
                <th>Doc. Sap</th>
                <th>Cliente</th>
                <th>Fecha Doc</th>
                <th>Total</th>
                <th>Condición Pago</th>
                <th>Estado</th>
                <th>Responsable</th>
                <th>Fecha Seguimiento</th>
                <th>Vendedor</th>
              </tr>
            </thead>
            <tbody>
    `;
    
    // Usar el índice del forEach para crear el correlativo
    registrosParaImprimir.forEach((item, index) => {
      const numeroLinea = index + 1; // Para que empiece en 1 en lugar de 0
      
      contenidoHTML += `
        <tr>
          <td>${numeroLinea}</td> <!-- Aquí usamos el correlativo generado -->
          <td>${item.Num_Ref || '-'}</td>
          <td>${item.Num_Documento || '-'}</td>
          <td>${item.Codigo_Cliente + ' -\n ' + item.Nombre_CLiente || '-'}</td>
          <td>${formatearFecha(item.Fecha_Doc) || '-'}</td>
          <td>Q ${item.Total_Documento?.toFixed(2) || '0.00'}</td>
          <td>${item.Condicion_Pago || '-'}</td>
          <td>${item.est_nombre || '-'}</td>
          <td>${item.nombre_departamento || '-'}</td>
          <td>${formatearFecha(item.sp_fecha) || '-'}</td>
          <td>${item.Vendedor || '-'}</td>
        </tr>
      `;
    });

    contenidoHTML += `
            </tbody>
          </table>
          <div class="no-print" style="margin-top: 20px; text-align: center;">
            <button onclick="window.print()" style="padding: 8px 16px; background: #4CAF50; color: white; border: none; border-radius: 4px; cursor: pointer;">
              Imprimir Reporte
            </button>
            <button onclick="window.close()" style="padding: 8px 16px; background: #f44336; color: white; border: none; border-radius: 4px; cursor: pointer; margin-left: 10px;">
              Cerrar Ventana
            </button>
          </div>
        </body>
      </html>
    `;
    ventanaImpresion.document.open();
    ventanaImpresion.document.write(contenidoHTML);
    ventanaImpresion.document.close();
  }

  return (
    <div className="container mt-4">
      {/* Modal de confirmación de seguimiento */}
      {showModal && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">
                  {accionActual === 'editar' ? 'Editar Seguimiento' : 'Cerrar Seguimiento'}
                </h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="row mb-4">
                  <div className="col-md-6">
                    <p><strong>No. Referencia:</strong> {liquidacionSeleccionada?.Num_Ref}</p>
                    <p><strong>Cliente:</strong> {liquidacionSeleccionada?.Nombre_CLiente}</p>
                    <p><strong>Documento:</strong> {liquidacionSeleccionada?.Num_Documento}</p>
                    <p><strong>Código Cliente:</strong> {liquidacionSeleccionada?.Codigo_Cliente}</p>
                  </div>
                  <div className="col-md-6">
                    <p><strong>Fecha Doc.:</strong> {formatearFecha(liquidacionSeleccionada?.Fecha_Doc)}</p>
                    <p><strong>Total:</strong> Q {liquidacionSeleccionada?.Total_Documento?.toFixed(2)}</p>
                    <p><strong>Estado Actual:</strong>
                      <span className={`badge ${liquidacionSeleccionada?.Pagado === 'No Pagada' ? 'bg-danger' : 'bg-success'}`}>
                        {liquidacionSeleccionada?.Pagado}
                      </span>
                    </p>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4 mb-3">
                    <label className="form-label">Estado:</label>
                    <select
                      className="form-select"
                      value={estadoSeleccionado}
                      onChange={(e) => setEstadoSeleccionado(e.target.value)}
                      required
                      disabled={accionActual === ''}
                    >
                      <option value="">Seleccione estado</option>
                      {opcionesEstado.map((opcion) => (
                        <option key={opcion.est_codigo} value={opcion.est_codigo}>
                          {opcion.est_nombre}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label"> Area Responsable:</label>
                    <select
                      className="form-select"
                      value={arearesponsableSeleccionado}
                      onChange={(e) => setareaResponsableSeleccionado(e.target.value)}
                    >
                      <option value="">Seleccione un responsable</option>
                      {opcionesArea.map((resp) => (
                        <option key={resp.id} value={resp.est_codigo}>
                          {resp.est_nombre}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Comentario:</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    value={comentario}
                    onChange={(e) => setComentario(e.target.value)}
                    placeholder="Ingrese comentarios sobre el seguimiento"
                  ></textarea>
                </div>

                <div className="alert alert-warning">
                  {accionActual === 'editar'
                    ? '¿Está seguro que desea actualizar este seguimiento?'
                    : '¿Está seguro que desea cerrar este seguimiento?'}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className={accionActual === 'editar' ? 'btn btn-primary' : 'btn btn-success'}
                  onClick={confirmarAccion}
                  disabled={cargando}
                >
                  {cargando ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  ) : (
                    accionActual === 'editar' ? 'Actualizar Seguimiento' : 'Cerrar Seguimiento'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Sidebar para mostrar tabla */}
      {showSidebar && (
        <div className="offcanvas offcanvas-end show" style={{ width: '80%' }} tabIndex="-1">
          <div className="offcanvas-header bg-primary text-white">
            <h5 className="offcanvas-title">Resumen de Liquidaciones</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={() => setShowSidebar(false)}
            ></button>
          </div>
          <div className="offcanvas-body">
            <div className="table-responsive">
              <table className="table table-striped table-hover">
                <thead className="table-dark">
                  <tr>
                    <th>Factura</th>
                    <th>Documento</th>
                    <th>Cliente</th>
                    <th>Fecha</th>
                    <th>Total</th>
                    <th>Condición</th>
                    <th>Estado</th>
                    <th>Responsable</th>
                    <th>Fecha Seg.</th>
                  </tr>
                </thead>
                <tbody>
                  {sidebarData.map((item, index) => (
                    <tr key={index}>
                      <td>{item.factura}</td>
                      <td>{item.documento}</td>
                      <td>{item.cliente}</td>
                      <td>{item.fecha}</td>
                      <td>{item.total}</td>
                      <td>{item.condicion}</td>
                      <td>
                        <span className={`badge ${item.estado === 'Liquidado' ? 'bg-success' : 'bg-warning'}`}>
                          {item.estado}
                        </span>
                      </td>
                      <td>{item.responsable}</td>
                      <td>{item.fechaSeguimiento}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="mt-3">
              <p className="text-muted">
                <strong>Total de registros:</strong> {sidebarData.length}
              </p>
            </div>
          </div>
        </div>
      )}

      <div className="card border-0 shadow-none">
        <div className="card-header bg-transparent border-0 px-0 pt-0">
          <h1 className="text-center mb-4">Consulta de Liquidaciones</h1>
        </div>

        <div className="card-body px-0">
          <form onSubmit={handleSubmit} className="mb-4">
            <div className="row g-3 align-items-center">
              <div className="col-md-4">
                <label htmlFor="fechaConsulta" className="form-label">Fecha de Factura:</label>
                <input
                  type="date"
                  id="fechaConsulta"
                  className="form-control"
                  value={fechaConsulta}
                  onChange={handleFechaChange}
                  disabled={!usarFecha}
                />
              </div>
              <div className="col-md-4">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="usarFechaCheckbox"
                    checked={usarFecha}
                    onChange={(e) => setUsarFecha(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="usarFechaCheckbox">
                    Solo Pendiente
                  </label>
                  <br />
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="usarFechaCheckbox2"
                    checked={usarFecha2}
                    onChange={(e) => setUsarFecha2(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="usarFechaCheckbox2">
                    Rango de Fechas
                  </label>
                </div>
              </div>
              {usarFecha2 && (
                <div className="col-md-4">
                  <label htmlFor="fechaConsulta" className="form-label">Fecha de Factura:</label>
                  <input
                    type="date"
                    id="fechaConsulta"
                    className="form-control"
                    value={fechaConsulta1}
                    onChange={handleFechaChange1}
                  />
                  <label htmlFor="fechaConsulta" className="form-label">Fecha de Factura:</label>
                  <input
                    type="date"
                    id="fechaConsulta"
                    className="form-control"
                    value={fechaConsulta2}
                    onChange={handleFechaChange2}
                  />
                </div>
              )}
              <div className="col-md-4 d-flex align-items-end">
                <button
                  type="submit"
                  disabled={cargando}
                  className="btn btn-success"
                >
                  {cargando ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Consultando...
                    </>
                  ) : 'Consultar'}
                </button>
              </div>
            </div>
          </form>
          <form className="mb-3">
            <div className="row g-2 align-items-end">
              <div className="col-sm-2">
                <label className="form-label">Factura.</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Ref."
                  name="numRef"
                  value={filters.numRef}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="col-sm-2">
                <label className="form-label">Documento</label>
                <input
                  type="num"
                  className="form-control form-control-sm"
                  placeholder="Doc."
                  name="documento"
                  value={filters.documento}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="col-sm-2">
                <label className="form-label">DISTRIBUIDORA</label>
                <input
                  type="num"
                  className="form-control form-control-sm"
                  placeholder="Doc."
                  name="factura"
                  value={filters.factura}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="col-sm-2">
                <label className="form-label">Código Cliente</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Código"
                  name="cliente"
                  value={filters.cliente}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="col-sm-2">
                <label className="form-label">Condición</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Condición"
                  name="condicionPago"
                  value={filters.condicionPago}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="col-sm-2">
                <label className="form-label">Estado</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Estado"
                  name="estado"
                  value={filters.estado}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="col-auto ms-auto">
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={handleLimpiarFiltros}
                >
                  <i className="fas fa-times-circle me-1"></i> Limpiar Filtros
                </button>
              </div>
            </div>
          </form>
          <div className="container">
            <div className="row">
              <div className="col-md-3">
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={imprimirRegistrosEstado6}
                  disabled={cargando || filteredData.length === 0}
                  title="Imprimir registros con estado 6"
                >
                  <i className="fas fa-print fa-sm me-1"></i> Imprimir Liquidacion
                </button>
              </div>

              {/* Nuevo botón para mostrar sidebar */}
              <div className="col-md-2">
                <button
                  type="button"
                  className="btn btn-warning btn-sm"
                  onClick={handleShowSidebar}
                  disabled={cargando || filteredData.length === 0}
                  title="Ver resumen en tabla"
                >
                  <i className="fas fa-table fa-sm me-1"></i> Ver Resumen
                </button>
              </div>

              {user.rol.some(rol => rol.Id_Perfil === 140004 || rol.Id_Perfil === 1
              ) && (
                  <div className="col-md-1 offset-md-6">
                    <button
                      type="button"
                      className="btn btn-info btn-sm"
                      onClick={enviarnotificaciones}
                      disabled={cargando || filteredData.length === 0}
                      title="Enviar Corre"
                    >
                      <i className="fas fa-envelope fa-sm me-1"></i> Enviar Seguimientos
                    </button>
                  </div>
                )}
            </div>
            <div className="row mt-3 mb-3">
              <div className="col-12">
                <div className="d-flex flex-wrap gap-2">
                  <button
                    className={`btn btn-sm ${filtrosActivos.length === 0 ? 'btn-primary' : 'btn-outline-primary'}`}
                    onClick={() => setFiltrosActivos([])}
                  >
                    Todos ({respuestaApi.length})
                  </button>

                  {gruposEstado.map((grupo) => {
                    const colorMap = {
                      1: 'btn-primary',
                      2: 'btn-secondary',
                      3: 'btn-danger',
                      4: 'btn-info',
                      5: 'btn-dark',
                      6: 'btn-success',
                      7: 'btn-purple',
                      8: 'btn-indigo',
                      9: 'btn-orange',
                      10: 'btn-teal',
                      11: 'btn-pink',
                      12: 'btn-blue',
                      13: 'btn-brown',
                      14: 'btn-cyan',
                      15: 'btn-warning',
                      16: 'btn-lime',
                      17: 'btn-maroon'
                    };
                    const colorClass = colorMap[grupo.est_codigo] || 'btn-primary';

                    return (
                      <button
                        key={`${grupo.est_codigo}-${grupo.est_nombre}`}
                        className={`btn btn-sm ${filtrosActivos.includes(grupo.est_codigo) ? colorClass : colorClass.replace('btn-', 'btn-outline-')}`}
                        onClick={() => {
                          if (filtrosActivos.includes(grupo.est_codigo)) {
                            setFiltrosActivos(filtrosActivos.filter(id => id !== grupo.est_codigo));
                          } else {
                            setFiltrosActivos([...filtrosActivos, grupo.est_codigo]);
                          }
                        }}
                      >
                        {grupo.est_nombre} ({grupo.count})
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>

          {error && (
            <div className="alert alert-danger d-flex justify-content-between align-items-center">
              <span>Error: {error}</span>
              <button onClick={consultarApi} className="btn btn-sm btn-danger">
                Reintentar
              </button>
            </div>
          )}

          <div className="table-responsive">
            <h2 className="mb-3">Resultados de Liquidaciones</h2>
            {cargando ? (
              <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Cargando...</span>
                </div>
                <p className="mt-2">Cargando datos...</p>
              </div>
            ) : filteredData.length > 0 ? (

              <div className="row">
                {filteredData.map((item, index) => (

                  <div key={index} className="col-12 mb-4">
                    <div className="card shadow-sm">
                      <div className={validateStyleCard(item.est_nombre)}>
                        <div>
                          <h5 className="mb-0 d-inline-block me-3">{item.Nombre_CLiente}</h5>
                          <span className="badge bg-secondary me-2">Código: {item.Codigo_Cliente}</span>
                          <span className={`badge ${item.Pagado === 'No Pagada' ? 'bg-danger' : 'bg-success'}`}>
                            {item.Pagado}
                          </span>
                        </div>
                        <div>
                          <button
                            onClick={() => handleShowBitacora(item)}
                            className="btn btn-info btn-sm me-2"
                            title="Ver bitácora"
                          >
                            <i className="fas fa-history me-1"></i> Bitácora
                          </button>
                          <a
                            href={`https://report.feel.com.gt/ingfacereport/ingfacereport_documento?uuid=${item.U_FE_IDGFace}`}
                            className="btn btn-primary btn-sm"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fas fa-file-invoice me-1"></i> FACTURA
                          </a>
                        </div>
                      </div>

                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="mb-3">
                              <label className="form-label text-muted small mb-1">Distribuidora</label>
                              <p className="form-control-plaintext">{item.Distribuidora}</p>
                            </div>

                            <div className="mb-3">
                              <label className="form-label text-muted small mb-1">No. Factura / Doc SAP</label>
                              <p className="form-control-plaintext">{item.Num_Ref} / {item.Num_Documento}</p>
                            </div>

                            <div className="mb-3">
                              <label className="form-label text-muted small mb-1">Fechas</label>
                              <div className="d-flex gap-3">
                                <div>
                                  <small className="text-muted">Emisión</small>
                                  <p className="form-control-plaintext">{formatearFecha(item.Fecha_Doc)}</p>
                                </div>
                                <div>
                                  <small className="text-muted">Vencimiento</small>
                                  <p className="form-control-plaintext">{formatearFecha(item.Fecha_Ven)}</p>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="mb-3">
                              <label className="form-label text-muted small mb-1">Total Documento</label>
                              <h5 className="text-primary">Q {item.Total_Documento?.toFixed(2)}</h5>
                            </div>

                            <div className="mb-3">
                              <label className="form-label text-muted small mb-1">Condición de Pago</label>
                              <p className="form-control-plaintext">{item.Condicion_Pago}</p>
                            </div>

                            <div className="mb-3">
                              <label className="form-label text-muted small mb-1">Liquidación  </label>
                              <br />
                              <span className={`badge ${item['Liquidacion Documento'] === 'Efectivo' ? 'bg-success' : 'bg-primary'}`}
                                style={{
                                  display: 'inline-block',
                                  maxWidth: '350px',
                                  whiteSpace: 'wrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis'
                                }}
                              >
                                {item['Liquidacion Documento']}
                              </span>
                              {item['Motivo No Liquidado'] && (
                                <p className="text-danger small mt-1">{item['Motivo No Liquidado']}</p>
                              )}
                            </div>
                            <div className="mb-3">
                              <label className="form-label text-muted small mb-1">Vendedor  </label>
                              <p className="form-control-plaintext">{item.Vendedor}</p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="mb-3">
                              <label className="form-label text-muted small mb-1">Logística</label>
                              <p className="form-control-plaintext small">
                                Ruta: {item.Ruta} | Vehículo: {item.Vehiculo}
                              </p>
                              <p className="form-control-plaintext small">
                                Piloto: {item.Piloto} | Ayudante: {item.Ayudante}
                              </p>
                            </div>

                            <div className="mb-3">
                              <label className="form-label text-muted small mb-1">Seguimiento</label>
                              <p className="form-control-plaintext small">
                                <strong>Responsable:</strong> {item.nombre_departamento}<br />
                                <strong>Inicio:</strong> {formatearFecha(item.sp_fecha)}<br />
                                <strong>Días:</strong> {item.sp_dias_caso}<br />
                                <strong>Estado:</strong> {item.est_nombre}<br />
                                <strong>Ultimo Comentario:</strong> {item.sp_comentario}<br />
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {(item.est_nombre !== "Liquidado" || user.rol.some(rol => rol.Id_Perfil === 140002 || rol.Id_Perfil === 140001 || rol.Id_Perfil === 140000
                        || rol.Id_Perfil === 1
                      )) && (
                          <div className="card-footer bg-white d-flex justify-content-end gap-2">

                            <button
                              onClick={() => handleEditarSeguimientoClick(item)}
                              disabled={cargandoSeguimiento}
                              className="btn btn-warning btn-sm"
                            >
                              <i className="fas fa-edit me-1"></i> Editar Seguimiento
                            </button>

                            {user.rol.some(rol => rol.Id_Perfil === 140002 || rol.Id_Perfil === 140001 || rol.Id_Perfil === 140000
                              || rol.Id_Perfil === 1
                            ) && (
                                <button
                                  onClick={() => handleCerrarSeguimientoClick(item)}
                                  disabled={cargandoSeguimiento}
                                  className="btn btn-success btn-sm"
                                >
                                  <i className="fas fa-check-circle me-1"></i> Cerrar Caso
                                </button>)}
                          </div>
                        )}
                    </div>
                    {showBitacoraModal && bitacoraItem && (
                      <div className="modal fade show" style={{ display: 'block', backgroundColor: 'black' }}>
                        <div className="modal-dialog modal-lg">
                          <div className="modal-content">
                            <div className="modal-header bg-info text-white">
                              <h5 className="modal-title">Bitácora de Seguimiento - Historial Completo</h5>
                              <button type="button" className="btn-close btn-close-white" onClick={() => setShowBitacoraModal(false)}></button>
                            </div>
                            <div className="modal-body">
                              <div className="mt-4">
                                <table className="table table-striped">
                                  <thead>
                                    <tr>
                                      <th>Responsable</th>
                                      <th>Comentario</th>
                                      <th>Fecha</th>
                                      <th>Usuario</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {(() => {
                                      if (!bitacoraItem.Bitacora || typeof bitacoraItem.Bitacora !== "string") {
                                        return <tr><td colSpan="4">Datos no disponibles</td></tr>;
                                      }
                                      let parsedData;
                                      try {
                                        parsedData = JSON.parse(bitacoraItem.Bitacora);
                                      } catch {
                                        return <tr><td colSpan="4">Formato inválido</td></tr>;
                                      }
                                      if (!Array.isArray(parsedData)) {
                                        return <tr><td colSpan="4">Estructura incorrecta</td></tr>;
                                      }
                                      if (parsedData.length === 0) {
                                        return <tr><td colSpan="4">No hay registros</td></tr>;
                                      }
                                      return parsedData.map((item, index) => (
                                        <tr key={index}>
                                          <td>{item.Responsable || "-"}</td>
                                          <td>{item.Comentario || "-"}</td>
                                          <td>{item.Fecha ? new Date(item.Fecha).toLocaleString() : "-"}</td>
                                          <td>{item.UsuarioModifica || "-"}</td>
                                        </tr>
                                      ));
                                    })()}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => setShowBitacoraModal(false)}
                              >
                                Cerrar
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div className="alert alert-info">
                {respuestaApi.length === 0
                  ? 'No se encontraron liquidaciones para la fecha seleccionada.'
                  : 'No hay resultados que coincidan con los filtros aplicados.'}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditarLiquidaciones;